import moment from 'moment';
import Abstract from './Abstract.js';

export default class RowMilestones extends Abstract {
  constructor(props) {
    super(props);
    this.mileRow = null;
  }

  build() {
    const { chart, data, options } = this.props;

    if (options.showMilestones) {
      const milestones = data.lines.map((mile) => {
        const startDate = moment(mile.date_at).set({
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0,
        });

        const endDate = moment(mile.date_at).set({
          hour: 23,
          minute: 59,
          second: 59,
          millisecond: 999,
        });

        return {
          ...mile,
          type: 'milestone',
          title: '',
          startDate,
          endDate,
        };
      });

      const group = chart
        .selectAll('svg')
        .data(milestones)
        .enter()
        .append('g')
        .attr('class', 'group-mile');

      this.mileRow = group
        .append('rect')
        .attr(
          'class',
          (d) =>
            `mile ${d.childMilestone.some((m) => m.portfolio_id) ? 'portfolio' : ''}`
        )
        .attr('width', 2)
        .attr('x', (d) => this.getVisibleStartX(d))
        .attr('y', 0)
        .attr('height', options.height);
    }
  }

  update() {
    const { options } = this.props;

    if (options.showMilestones) {
      this.mileRow
        .transition()
        .duration(this.transitionDuration)
        .attr('x', (d) => this.getVisibleStartX(d));
    }
  }

  getVisibleStartX(datum) {
    return this.getStartX(datum) + (this.getWidth(datum) - 2) / 2;
  }

  getStartX(datum) {
    return this.xScale(datum.startDate);
  }

  getEndX(datum) {
    return this.xScale(datum.endDate);
  }

  getWidth(datum) {
    return this.getEndX(datum) - this.getStartX(datum);
  }
}
